import { PieInnerText } from '@jana-technology/platform-ui/charts'

import type { PieInnerTextsProps } from './types'

const getInnerTextLabel = ({
  formatSeriesName = (seriesName) => seriesName,
  seriesName,
  hasMultipleSeries,
  label,
  singleSeriesLabel = label
}: {
  formatSeriesName?: (seriesName: string) => string
  seriesName: string
  hasMultipleSeries: boolean
  label: string
  singleSeriesLabel?: string
}) =>
  hasMultipleSeries
    ? `${formatSeriesName(seriesName)} – ${label}`
    : singleSeriesLabel

const getInnerTextTransform = (seriesLength: number, index: number) => {
  if (seriesLength > 1) {
    return `translate(0, ${index ? index * 28 : -28})`
  }
}

export const PieInnerTexts = ({
  formatSeriesName,
  getValue,
  isVisible = true,
  label,
  series,
  singleSeriesLabel
}: PieInnerTextsProps) => {
  if (!isVisible || series.length === 0) {
    return null
  }

  const hasMultipleSeries = series.length > 1

  return series.map((seriesItem, index) => {
    const innerTextValue = getValue(seriesItem.name)

    if (innerTextValue == null) {
      return null
    }

    return (
      <g
        key={seriesItem.name}
        transform={getInnerTextTransform(series.length, index)}
      >
        <PieInnerText
          label={getInnerTextLabel({
            formatSeriesName,
            seriesName: seriesItem.name,
            hasMultipleSeries,
            label,
            singleSeriesLabel
          })}
          value={innerTextValue}
        />
      </g>
    )
  })
}
